import script from "./EmarsysToast.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmarsysToast.vue?vue&type=script&setup=true&lang=ts"

import "./EmarsysToast.vue?vue&type=style&index=0&id=0b549acc&lang=postcss"
import "./EmarsysToast.vue?vue&type=style&index=1&id=0b549acc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b549acc"]])

export default __exports__